const application = {
    invalid_type: 'Seules les applications machine à machine peuvent avoir des rôles associés.',
    role_exists: "Le rôle d'identifiant {{roleId}} a déjà été ajouté à cette application.",
    invalid_role_type: "Impossible d'assigner un rôle de type utilisateur à une application machine à machine.",
    invalid_third_party_application_type: 'Seules les applications Web traditionnelles peuvent être marquées comme une application tierce.',
    third_party_application_only: 'La fonctionnalité est uniquement disponible pour les applications tierces.',
    user_consent_scopes_not_found: 'Portées de consentement utilisateur invalides.',
    /** UNTRANSLATED */
    consent_management_api_scopes_not_allowed: 'Management API scopes are not allowed.',
    protected_app_metadata_is_required: "Les métadonnées d'application protégée sont requises.",
    /** UNTRANSLATED */
    protected_app_not_configured: 'Protected app provider is not configured. This feature is not available for open source version.',
    /** UNTRANSLATED */
    cloudflare_unknown_error: 'Got unknown error when requesting Cloudflare API',
    /** UNTRANSLATED */
    protected_application_only: 'The feature is only available for protected applications.',
    /** UNTRANSLATED */
    protected_application_misconfigured: 'Protected application is misconfigured.',
    /** UNTRANSLATED */
    protected_application_subdomain_exists: 'The subdomain of Protected application is already in use.',
    /** UNTRANSLATED */
    invalid_subdomain: 'Invalid subdomain.',
    /** UNTRANSLATED */
    custom_domain_not_found: 'Custom domain not found.',
    /** UNTRANSLATED */
    should_delete_custom_domains_first: 'Should delete custom domains first.',
};
export default Object.freeze(application);
